import uniq from 'lodash.uniq';
import {ColumnTypes} from 'src/modules/events/constants';
import {EventBasicInfo} from 'src/openapi/models/EventBasicInfo';

export const BLANK = '(Blank)';

export const extractColumnHeaderData = (filteredRows: EventBasicInfo[], columnType: ColumnTypes): string[] => {
    if (columnType === ColumnTypes.EVENT_FAMILIES) {
        return uniq(filteredRows.flatMap(row =>
            (row[ColumnTypes.EVENT_FAMILIES].length ? row[ColumnTypes.EVENT_FAMILIES] : [BLANK]),
        ));
    }

    if (columnType === ColumnTypes.EVENT_ATTRIBUTES) {
        return uniq(filteredRows.flatMap(row => row[ColumnTypes.EVENT_ATTRIBUTES])
            .map(attribute => attribute.name));
    }

    return uniq(filteredRows.map(row => row[columnType] as string));
};
